import React from "react";

export const sideBarDoctor = [
	{
		title: "View Current Appointments",
		link: "/dashboard/doctor/currentappt",
	},
	{
		title: "View Earnings Reports",
		link: "/dashboard/doctor/viewearnrep",
	},
	{
		title: "Make Service",
		link: "/dashboard/doctor/service",
	},
	{
		title: "View Past Appointments",
		link: "/dashboard/doctor/pastappt",
	},
	{
		title: "View Pending Appointments",
		link: "/dashboard/doctor/pendingAppointments",
	},
];
